import React from "react";
import "./style.css";

function Navbar() {
  return (
    <nav className="header">
      <h1>Employee Directory</h1>
      <p>Click on carrots to filter by heading or use the search box to narrow your results</p>
    </nav>
  );
}

export default Navbar;
